import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import inst from "../assets/Ins.png";
import face from "../assets/Face.png";
import you from "../assets/You.png";
import lin from "../assets/Lin.png";
import twi from "../assets/Twi.png";
import news from "../assets/News.png";
import phonee from "../assets/phone.png";
import mail from "../assets/Mail.png";
import loc from "../assets/Loc.png";
import nlen from "../assets/Nlen.svg";
import user from "../assets/user.png";  
import SearchIcon from "../assets/icons/search.svg";
import CalenderIcon from "../assets/icons/calender.svg";
import UserIcon from "../assets/icons/user.svg";
import TagIconSecondary from "../assets/icons/tag-icon.svg";
import BusinessIcon from "../assets/icons/bussiness-icon.svg";
import ConsultingIcon from "../assets/icons/consulting-icon.svg";
import UIUXDesignIcon from "../assets/icons/ui-ux-icon.svg";
import ITServicesIcon from "../assets/icons/it-service-icon.svg";
import LogisticsIcon from "../assets/icons/logistics-icon.svg";
import CaseStudyIcon from "../assets/icons/case-study-icon.svg";
import FinancialIcon from "../assets/icons/bussiness-icon.svg";
import UserResearchIcon from "../assets/icons/bussiness-icon.svg";
import DefaultIcon from "../assets/icons/bussiness-icon.svg";
import backBtn from "../assets/icons/back-btn.svg";

import { toast, ToastContainer } from "react-toastify";
import { useParams, useNavigate } from "react-router-dom";
import "../BlogDetail.css";

import { Link } from "react-router-dom";
import { Helmet } from "react-helmet";

const BlogLanding = () => {

  
    const [form, setForm] = useState({ name: "", message: "" });
    const { slug } = useParams();
    const navigate = useNavigate();
    const [post, setPost] = useState(null);
    const [data, setData] = useState("");
    const [sessionid, setSessionid] = useState("");
    const [email, setEmail] = useState("");
    const [token, setToken] = useState("");
    const [categories, setCategories] = useState([]);
    const [recentposts, setRecentPosts] = useState([]);
    const [loading, setLoading] = useState(true);

    const [searchQuery, setSearchQuery] = useState("");
    const [suggestions, setSuggestions] = useState([]);
    const [searchLoading, setSearchLoading] = useState(false);

    const categoryIcons = {
      1: BusinessIcon,
      2: ConsultingIcon,
      4: UIUXDesignIcon,
      27: ITServicesIcon,
      28: LogisticsIcon,
      46: CaseStudyIcon,
    };

    // fetch recent posts
    const fetchRecentPosts = async () => {
      const res = await fetch(
        "https://blog.lentera.in/wp-json/wp/v2/posts?per_page=5&orderby=date&order=desc&_fields=id,slug,title"
      );
      const data = await res.json();
      setRecentPosts(data);
    };
    // Fetch Categories
    const fetchCategories = async () => {
      const res = await fetch(
        "https://blog.lentera.in/wp-json/wp/v2/categories?_fields=id,name,slug,count"
      );
      const data = await res.json();

      const filtered = data.filter(cat => cat.count > 0);
      
      setCategories(filtered);
    };

    useEffect(() => {
      fetchCategories();
      fetchRecentPosts();
    }, []);

    useEffect(() => {
      const fetchPost = async () => {
        try {
          setLoading(true);
          const res = await fetch(
            `https://blog.lentera.in/wp-json/wp/v2/posts?slug=${slug}&_embed`
          );
          const data = await res.json();

          if (!Array.isArray(data) || data.length === 0) {
            setPost(false);
            setLoading(false);
            return;
          }

          setPost(data[0]);
          console.log(post);
          setLoading(false);

        } catch (err) {
          setPost(false);
          setLoading(false);
        }
      };

      fetchPost();
    }, [slug]);

    useEffect(() => {
      if (!searchQuery) {
        setSuggestions([]);
        return;
      }

      const delay = setTimeout(() => {
        fetchSearchSuggestions();
      }, 400);

      return () => clearTimeout(delay);
    }, [searchQuery]);


    const fetchSearchSuggestions = async () => {
      try {
        setSearchLoading(true);

        const res = await fetch(
          `https://blog.lentera.in/wp-json/wp/v2/posts?search=${searchQuery}&per_page=6&_fields=id,slug,title.rendered`
        );
        const data = await res.json();

        const matched = data.filter(post =>
          post.title.rendered.toLowerCase().includes(searchQuery.toLowerCase())
        );

        setSuggestions(matched.slice(0, 6));
      } catch (err) {
        setSuggestions([]);
      } finally {
        setSearchLoading(false);
      }
    };


    useEffect(() => {
      fetch("https://api.app.mawalog.com/v1.2/website")
        .then((response) => response.json())
        .then((json) => {
          setData(json.data.captcha_code);
          setSessionid(json.data.session_id);
          setToken(json.data.token);
        })
        .catch((error) => console.error("Error fetching data:", error));
    }, []);
    
    useEffect(() => {
    const canvas = document.getElementById("captchaCanvas");
    if (canvas) {
      const ctx = canvas.getContext("2d");
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      ctx.font = "bold 18px Arial";
      ctx.fillStyle = "#00377B";
      ctx.fillText(data, 10, 22);
    }
  }, [data]);
  
    const handleChange = (e) => {
      setEmail(e.target.value);
    };
   
     const canvasRef = useRef(null);
    const [captchaValue, setCaptchaValue] = useState(""); // text from API
    const [userCaptcha, setUserCaptcha] = useState("");
   
    /* ------------------------------------------------------------------- API fetch */
    const fetchCaptcha = async () => {
      try {
        const res = await fetch(
          "https://api.app.mawalog.com/v1.2/website"
        );
        const json = await res.json();
        setCaptchaValue(json.data.captcha_code ?? "ERROR"); // fallback if NULL
      } catch (err) {
        console.error("Error fetching captcha:", err);
      }
    };
   
    /* -- fetch once on mount ------------------------------------------------------- */
    useEffect(() => {
      fetchCaptcha();
    }, []);
   
    /* -- redraw every time captchaValue changes ------------------------------------ */
   useEffect(() => {
    if (!data) return;
    const canvas = canvasRef.current;
    if (!canvas) return;
  
    const ctx = canvas.getContext("2d");
    const W = canvas.width;
    const H = canvas.height;
  
    ctx.clearRect(0, 0, W, H);
    ctx.fillStyle = "#ffffff";
    ctx.fillRect(0, 0, W, H);
  
    for (let i = 0; i < 3; i++) {
      ctx.beginPath();
      ctx.moveTo(Math.random() * W, Math.random() * H);
      ctx.bezierCurveTo(
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H,
        Math.random() * W,
        Math.random() * H
      );
      ctx.lineWidth = 1 + Math.random();
      ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
      ctx.stroke();
    }
  
    ctx.font = "bold 22px Arial";
    ctx.fillStyle = "#0A3A72";
    const chars = data.toString().split("");
  
    chars.forEach((ch, i) => {
      const angle = (Math.random() - 0.5) * 0.8;
      const x = 8 + i * 14 + (Math.random() * 4 - 2);
      const y = 22 + (Math.random() * 6 - 3);
  
      ctx.save();
      ctx.translate(x, y);
      ctx.rotate(angle);
      ctx.fillText(ch, 0, 0);
      ctx.restore();
    });
  
    for (let i = 0; i < 45; i++) {
      ctx.beginPath();
      ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
      ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
      ctx.fill();
    }
  }, [data]);

   const [name, setName] = useState("");
  
   const [phone, setPhone] = useState("");
  
    // Fetch session ID and token
    useEffect(() => {
      fetch("http://localhost/maw-lumen/sonar-qube/admin_api/book_demo")
        .then((response) => response.json())
        .then((json) => {
          setSessionid(json.data.session_idd);
          setToken(json.data.token);
        })
        .catch((error) => console.error("Error fetching token/sessionid:", error));
    }, []);
  
    // Fetch captcha value
    const fetchCaptchaa = async () => {
      try {
        const res = await fetch("http://localhost/maw-lumen/sonar-qube/admin_api/book_demo");
        const json = await res.json();
        setCaptchaValue(json.data.captcha_code ?? "ERROR");
        setSessionid(json.data.session_id);
        setToken(json.data.token);
      } catch (err) {
        console.error("Error fetching captcha:", err);
      }
    };
  
    useEffect(() => {
      fetchCaptcha();
    }, []);

  const handleSubmit = async (e) => {
      e.preventDefault();
      if (!name || !email || !phone) {
        setFormError("Please fill all fields.");
        setFormSuccess("");
        return;
      }
  
      setFormError("");
  
      try {
        const captchaRes = await fetch("http://localhost/maw-lumen/sonar-qube/admin_api/book_demo");
        const captchaJson = await captchaRes.json();
  
        const response = await fetch(
          "http://localhost/maw-lumen/sonar-qube/admin_api/book_demo",
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              "X-CSRF-TOKEN": token,
            },
            body: JSON.stringify({
              session_id: captchaJson.data.session_id,
              captcha: captchaJson.data.captcha_code,
              name,
              email,
              phone,
            }),
          }
        );
  
        const result = await response.json();
  
        if (response.ok && (result.success || result.status)) {
          setFormSuccess("Message sent successfully!");
          setFormError("");
          setName("");
          setEmail("");
          setPhone("");
          fetchCaptcha();
          
  
        } else {
          setFormError(result.message || "Validation error.");
          setFormSuccess("");
        }
      } catch (error) {
        console.error("Error submitting form:", error);
        setFormError("Something went wrong. Try again.");
        setFormSuccess("");
      }
    };
  
     // Newsletter captcha refs/state (separate)
    const [submail, setSubmail] = useState("");
    const newsletterCanvasRef = useRef(null);
    const [newsCaptcha, setNewsCaptcha] = useState("");
    const [newsletterCaptcha, setNewsletterCaptcha] = useState({ code: "", sessionId: "", token: "" });
    const [newsletterUserCaptcha, setNewsletterUserCaptcha] = useState(""); // <-- new state for newsletter captcha input
    const [formError, setFormError] = useState("");
    const [formSuccess, setFormSuccess] = useState("");
    const handleReload = () => {
      fetchNewsletterCaptcha();
    };
  
    const fetchNewsletterCaptcha = async () => {
      try {
        const response = await fetch("https://api.app.mawalog.com/v1.2/website");
        const json = await response.json();
        if (json?.data) {
          setNewsletterCaptcha({ code: json.data.captcha_code, sessionId: json.data.session_id, token: json.data.token });
        }
      } catch (err) {
        console.error("Error fetching newsletter captcha:", err);
      }
    };
  
    useEffect(() => {
      // fetch both captchas on mount so both canvases are ready
      fetchNewsletterCaptcha();
    }, []);
  
    // Draw newsletter captcha whenever it changes
    useEffect(() => {
      if (!newsletterCaptcha?.code) return;
      const canvas = newsletterCanvasRef.current;
      if (!canvas) return;
  
      const ctx = canvas.getContext("2d");
      const W = canvas.width;
      const H = canvas.height;
  
      ctx.clearRect(0, 0, W, H);
      ctx.fillStyle = "#ffffff";
      ctx.fillRect(0, 0, W, H);
  
      // noise / curves
      for (let i = 0; i < 3; i++) {
        ctx.beginPath();
        ctx.moveTo(Math.random() * W, Math.random() * H);
        ctx.bezierCurveTo(
          Math.random() * W,
          Math.random() * H,
          Math.random() * W,
          Math.random() * H,
          Math.random() * W,
          Math.random() * H
        );
        ctx.strokeStyle = `rgba(0,0,0,${Math.random() * 0.25})`;
        ctx.lineWidth = 1 + Math.random();
        ctx.stroke();
      }
  
      // draw characters
      const chars = newsletterCaptcha.code.toString().split("");
      ctx.fillStyle = "#0A3A72";
      const fonts = ["Arial", "Verdana", "Georgia", "Courier New", "Times New Roman"];
      chars.forEach((ch, i) => {
        const angle = (Math.random() - 0.5) * 1.2;
        const x = 8 + i * 12 + (Math.random() * 4 - 2);
        const y = 24 + (Math.random() * 6 - 3);
        ctx.save();
        ctx.translate(x, y);
        ctx.rotate(angle);
        ctx.font = `bold ${16 + Math.floor(Math.random() * 6)}px ${fonts[Math.floor(Math.random() * fonts.length)]}`;
        ctx.fillText(ch, 0, 0);
        ctx.restore();
      });
  
      // dots
      for (let i = 0; i < 35; i++) {
        ctx.beginPath();
        ctx.arc(Math.random() * W, Math.random() * H, 1, 0, 2 * Math.PI);
        ctx.fillStyle = `rgba(0,0,0,${Math.random() * 0.4})`;
        ctx.fill();
      }
    }, [newsletterCaptcha]);
    const handleSubscribe = async (e) => {
    e?.preventDefault?.();
  
    // Basic email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  
    if (!submail) {
      toast("Please enter an email address");
      return;
    }
  
    if (!emailRegex.test(submail)) {
      toast("Please enter a valid email address");
      return;
    }
  
    if (!newsletterUserCaptcha) {
      toast("Please enter the captcha");
      return;
    }
  
    try {
      const res = await fetch("https://api.app.mawalog.com/v1.2/newsletter", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-TOKEN": newsletterCaptcha.token || "", // use newsletter token
        },
        body: JSON.stringify({
          session_id: newsletterCaptcha.sessionId || "", // use newsletter session id
          captcha: newsletterUserCaptcha, // use newsletter captcha input
          email: submail,
          type: "Mawalog",
        }),
      });
  
      const result = await res.json();
  
      // On success clear inputs and reload captcha
      if (res.ok) {
        setSubmail("");
        setNewsletterUserCaptcha("");
        fetchNewsletterCaptcha();
      }
  
      toast(result.message || "Subscription response received");
    } catch (err) {
      console.error("Newsletter subscribe error:", err);
      toast("Subscription failed. Please try again.");
    }
  };


  if (loading) {
    return (
      <div className="fixed inset-0 flex justify-center items-center bg-black/20 backdrop-brightness-90 z-50">
        <div className="w-10 h-10 border-4 border-gray-300 border-t-green-600 rounded-full animate-spin"></div>
      </div>
    );
  }

  if (post === false) {
    return (
      <div className="flex justify-center items-center h-[50vh]">
        <p className="text-green-700 text-xl font-semibold">Post Not Found</p>
      </div>
    );
  }


  const featuredImage = post._embedded?.["wp:featuredmedia"]?.[0]?.source_url;
  const postedOn = new Date(post.date).toLocaleDateString();
  const category = post._embedded?.["wp:term"]?.[0]?.[0]?.name;
  const author = post._embedded?.author?.[0]?.name;


  // Remove Elementor <style> tags if needed
  const content = post.content.rendered.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, "").replace(/ style="[^"]*"/gi, "");

  return (
    <>

      <Helmet>
        <title>{post?.title?.rendered || "Loading..."}</title>
        <meta name="description" content="Explore expert insights on AI, automation, machine learning, chatbots, software development, and digital innovation. Stay updated with the latest trends, strategies, and industry perspectives from Lentera Technologies.."/>
        <meta name="keywords" content=" AI blog, technology blog, machine learning insights, automation trends, software development articles, chatbot technology, digital innovation, AI solutions, tech updates, Lentera Technologies blog"/>
      </Helmet>

       <div className="sticky top-20 z-40 pointer-cursor">
          <div className="relative w-full h-0">
            <Link
              to="/blogs"
              className="absolute left-1 p-1 md:p-3"
            >
              <img src={backBtn} className="w-4 h-4 md:w-5 h-5" />
            </Link>
          </div>
        </div>

      <div className="bg-white px-4 sm:px-6 md:px-10 lg:px-12 xl:px-16 py-8 md:py-10">
      
        {/* MAIN GRID */}
        <div className="grid grid-cols-1 lg:grid-cols-[9fr_3fr] gap-8">

          {/* LEFT CONTENT */}
          <div className="blog-container bg-[#FBFBFB] border border-[#EFEFEF] rounded-lg p-4 sm:p-6 mb-6">

            <h1
              className="text-[#212129] font-semibold text-2xl sm:text-3xl md:text-[36px] mb-4 leading-snug"
              dangerouslySetInnerHTML={{ __html: post.title.rendered }}
            />

            {/* META INFO */}
            <div className="flex flex-wrap items-center gap-4 mb-8">

              {/* Date */}
              <div className="relative flex items-center">
                <img
                  src={CalenderIcon}
                  alt="calendar"
                  className="absolute left-0 top-1/2 -translate-y-1/2 w-5 h-5"
                />
                <span className="ml-7 text-sm font-medium leading-[24px] text-[#979797]">
                  {postedOn}
                </span>
              </div>

              {/* Separator */}
              <span className="hidden sm:block w-px h-6 bg-[#CED5DD]"></span>

              {/* Category */}
              <div className="relative flex items-center">
                <img
                  src={TagIconSecondary}
                  alt="user"
                  className="absolute left-0 top-1/2 -translate-y-1/2 w-5 h-5"
                />
                <span className="ml-7 text-sm font-medium leading-[24px] text-[#979797]">
                  {category}
                </span>
              </div>

              {/* Separator */}
              <span className="hidden sm:block w-px h-6 bg-[#CED5DD]"></span>

              {/* Author */}
              <div className="relative flex items-center">
                <img
                  src={UserIcon}
                  alt="tag"
                  className="absolute left-0 top-1/2 -translate-y-1/2 w-5 h-5"
                />
                <span className="ml-7 text-sm font-medium leading-[24px] text-[#979797]">
                  By {author}
                </span>
              </div>
            </div>

            {/* FEATURED IMAGE */}
            <div className="mb-8">
              <img
                src={featuredImage}
                alt={post.title.rendered}
                className="w-full rounded-md object-cover"
              />
            </div>

            {/* BLOG CONTENT */}
            <div
              className="blog-content"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          </div>

          {/* RIGHT SIDEBAR */}
          <div className="space-y-6">

            {/* SEARCH BOX */}
            <div className="p-4 border border-[#E5E5E5] rounded-lg">
              <h2 className="text-[#212129] font-semibold text-base uppercase mb-2">Search blogs</h2>

              <div className="relative w-full">
                <img
                  src={SearchIcon}
                  alt="search"
                  className="absolute left-3 top-1/2 -translate-y-1/2 w-5 h-5 opacity-70"
                />

                <input
                  type="text"
                  placeholder="Search blog title..."
                  value={searchQuery}
                  onChange={(e) => setSearchQuery(e.target.value)}
                  className="w-full border border-gray-300 rounded-xl pl-12 pr-4 py-2 focus:outline-none focus:ring-2 focus:ring-green-600"
                />
              </div>
              {searchQuery && (
                <div className="w-full mt-2 bg-white border border-[#E5E5E5] rounded-lg shadow-md z-50 p-2">

                  {searchLoading && (
                    <div className="p-3 text-sm text-gray-500 text-center">Searching…</div>
                  )}

                  {!searchLoading && suggestions.length === 0 && (
                    <div className="p-3 text-sm text-gray-500 text-center">No results found</div>
                  )}

                  {!searchLoading &&
                    suggestions.map((item) => (
                      <div
                        key={item.id}
                        className="p-3 bg-[#F9F9F9] rounded-lg mb-2 cursor-pointer hover:bg-[#F1F1F1]"
                        onClick={() => {
                          navigate(`/blog/${item.slug}`);
                          setSearchQuery("");
                          setSuggestions([]);
                        }}
                      >
                        <span
                          className="text-[#212129] font-medium text-sm leading-snug opacity-80"
                          dangerouslySetInnerHTML={{ __html: item.title.rendered }}
                        />
                      </div>
                    ))}
                </div>
              )}

            </div>

            {/* RECENT POSTS */}
            <div className="p-4 border border-[#E5E5E5] rounded-lg">
              <h2 className="text-[#212129] font-semibold text-base uppercase mb-3">Recent blogs</h2>

              <div>
                {recentposts.map((post) => (
                  <div className="p-3 bg-[#F9F9F9] rounded-lg mb-3 cursor-pointer" onClick={() => { navigate(`/blog/${post.slug}`); }}>
                    <span
                      className="text-[#212129] font-medium text-sm leading-snug opacity-80"
                      dangerouslySetInnerHTML={{ __html: post.title.rendered }}
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* CATEGORIES */}
            <div className="p-4 border border-[#E5E5E5] rounded-lg">
              <h2 className="text-[#212129] font-semibold text-base uppercase mb-3">Categories</h2>

              {categories.map((cat) => (
                <Link to={`/blogs/category/${cat.slug}`} key={cat.id}>
                  <div className="bg-[#F9F9F9] rounded-lg p-3 flex justify-between items-center mb-3">
                    <div className="relative">
                      <img
                        src={categoryIcons[cat.id] || DefaultIcon}
                        alt={cat.name}
                        className="absolute left-0 top-1/2 -translate-y-1/2 w-6 h-6"
                      />
                      <span className="pl-8 text-sm font-medium opacity-80">{cat.name}</span>
                    </div>
                    <span className="text-sm font-medium opacity-80">{cat.count}</span>
                  </div>
                </Link>
              ))}
            </div>

          </div>
        </div>


        {/* COMMENTS SECTION */}
       {/* <div className="grid grid-cols-1 lg:grid-cols-[9fr_3fr] gap-8 mt-10">
          <div className="bg-[#FBFBFB] p-4 sm:p-6 rounded-lg border border-[#EFEFEF]">

            <h1 className="text-2xl sm:text-3xl md:text-[32px] mb-3 font-semibold text-[#212129]">
              Comments
            </h1>

            <p className="text-sm text-[#212129] opacity-50 mb-8">
              Required fields are marked with <span className="text-red-700">*</span>
            </p>

            <form onSubmit={handleSubmit}>
              
              <div className="mb-6">
                <label className="text-[#21272CBF] font-medium text-sm uppercase">
                  Add your comment
                </label>
                <span className="text-red-700">*</span>

                <textarea
                  name="comment"
                  rows="6"
                  className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none resize-none"
                ></textarea>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-2 gap-3 mb-6">
                <div>
                  <label className="text-[#21272CBF] font-medium text-sm uppercase">
                    Name
                  </label>
                  <span className="text-red-700">*</span>

                  <input
                    type="text"
                    name="name"
                    value={form.name}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none"
                  />
                </div>

                <div>
                  <label className="text-[#21272CBF] font-medium text-sm uppercase">
                    Email
                  </label>
                  <span className="text-red-700">*</span>

                  <input
                    type="email"
                    name="email"
                    value={form.email}
                    onChange={handleChange}
                    className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none"
                  />
                </div>
              </div>

              <div className="flex items-start space-x-3 p-3 mb-6">
                <input
                  type="checkbox"
                  id="agree"
                  checked={form.agree}
                  onChange={(e) => setForm({ ...form, agree: e.target.checked })}
                  className="w-4 h-4"
                />

                <label htmlFor="agree" className="text-sm text-[#212129] opacity-70">
                  Save my name, email, and website in this browser for the next time I comment.
                </label>
              </div>

              <button className="bg-green-700 text-white font-bold text-base px-10 py-3 rounded-lg">
                Post comment
              </button>
            </form>
          </div>
        </div> */}

      </div>


        <div className="bg-[#111215] text-white">
         {/* Footer Section */}
          <footer className="px-4 sm:px-8 md:px-12 pt-12 pb-4">
            {/* Newsletter Section */}
            <div className="w-full bg-[#111215] max-w-[1312px] mx-auto rounded-[24px] md:rounded-[48px] px-4 sm:px-8 md:px-12 py-8 md:py-12 shadow-[0_25px_80px_0_rgba(0,0,0,0.05)] flex flex-col gap-10">
                  {/* Top newsletter */}
                  <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6 w-full">
                    {/* Left Side */}
                    <div className="flex items-start md:items-center gap-4 md:gap-6">
                      <img src={news} alt="newsletter" className="w-12 h-12 md:w-[80px] md:h-[80px]" />
                      <h2 className="text-xl md:text-[28px] font-bold leading-tight">
                        Join our newsletter to <br className="hidden md:block" />
                        keep up to date with us!
                      </h2>
                    </div>
      
                    <div className="flex flex-col items-center gap-4 w-full sm:w-[335px]">
                      {/* Newsletter input */}
                      <div
                        className="flex items-center bg-[#111215] border border-[#333] px-4 py-3 sm:px-6 sm:py-4 w-full"
                        style={{ borderRadius: "6px" }}
                      >
                        <img src={user} alt="user icon" className="w-5 h-5 mr-3" />
                        <input
                          type="email"
                          value={submail}
                          onChange={(e) => setSubmail(e.target.value)}
                          placeholder="Enter your email"
                          className="bg-transparent outline-none text-white placeholder-gray-400 w-full text-sm"
                        />
                      </div>
      
      
                      {/* Captcha line (canvas + refresh + input + subscribe button) */}
                      {/* Outer wrapper to center the row */}
                      <div className="w-full flex justify-center">
                        <div className="flex items-center gap-3">
                          {/* Captcha canvas */}
                          <div className="captcha-box">
                            <canvas
                              ref={newsletterCanvasRef}
                              id="newsletterCaptchaCanvas"
                              width={60}
                              height={40}
                              style={{ borderRadius: "6px", overflow: "hidden" }} // Optional inline for extra assurance
                            />
                          </div>
      
                          {/* Refresh button */}
                          <button
                            onClick={handleReload}
                            style={{
                              background: "#07862B ",
                              color: "#fff",
                              border: "none",
                              padding: "6px",
                              borderRadius: "6px",
                              cursor: "pointer",
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="18"
                              viewBox="0 0 24 24"
                              fill="none"
                              stroke="white"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            >
                              <polyline points="23 4 23 10 17 10"></polyline>
                              <polyline points="1 20 1 14 7 14"></polyline>
                              <path d="M3.51 9a9 9 0 0 1 14.13-3.36L23 10M1 14l5.36 4.36A9 9 0 0 0 20.49 15"></path>
                            </svg>
                          </button>
      
                          {/* Captcha input */}
                          <input
                            type="text"
                            placeholder="Enter captcha"
                            value={newsletterUserCaptcha}
                            onChange={(e) => setNewsletterUserCaptcha(e.target.value)}
                            className="captcha-input"
                          />
      
                          {/* Subscribe button */}
                          <button className="subscribe-button" onClick={handleSubscribe}>
                            Subscribe
                          </button>
                        </div>
                      </div>
      
                      <style>{`
        .captcha-box {
          width: 60px !important;
          height: 35px !important;
          border-radius: 6px !important;
          overflow: hidden !important;
          color :131519;
          background-color: #fff !important;
          box-shadow: 0 0 4px rgba(0, 0, 0, 0.1) !important;
          display: flex !important;
          align-items: center !important;
          justify-content: center !important;
        }
       
        .captcha-input {
          padding: 11px 8px !important;
          border-radius: 6px !important;
          border: 1px solid #ccc !important;
          outline: none !important;
          width: 100px !important;
          background: #131519 !important;
          color: #fff !important;
          font-size: 10px !important;
        }
       
        .subscribe-button {
          padding: 10px 16px !important;
          border-radius: 8px !important;
          border: none !important;
          background: #07862B !important;
          color: #fff !important;
          font-weight: bold !important;
          font-size: 13px !important;
          cursor: pointer !important;
          white-space: nowrap !important;
        }
       
        @media(max-width:480px){
          .captcha-input { width: 70px !important; font-size: 12px !important; }
          .subscribe-button { padding: 8px 12px !important; font-size: 12px !important; }
        }
      `}</style>
      
                    </div>
                  </div>
      
                  {/* Divider */}
                  <div className="border-t border-gray-700 w-full" />
      
                  {/* Main Footer Content */}
                  <div className="flex flex-col lg:flex-row flex-wrap justify-between items-start w-full gap-8 text-[16px]">
                    {/* Company Info */}
                    <div className="w-full lg:w-[30%]">
                      <a href="/" aria-label="Lentera Home">
                        <img src={nlen} alt="Lentera logo" className="mb-6" />
                      </a>
                      <p className="text-[#d4d4d4] leading-relaxed">
                        We are highly experienced in offering software development, mobile
                        application development, software consulting and project management
                        delivery.
                      </p>
                      {/* Social Icons */}
                      <div className="flex gap-4 mt-6 flex-wrap">
                        <a href="https://www.instagram.com/lenteratechnologies/?hl=en" target="_blank" rel="noopener noreferrer">
                          <img src={inst} alt="Instagram" className="w-8 h-8" />
                        </a>
                        <a href="https://www.facebook.com/lenteratechnologies/?ref=pages_you_manage" target="_blank" rel="noopener noreferrer">
                          <img src={face} alt="Facebook" className="w-8 h-8" />
                        </a>
                        <a href="https://www.youtube.com/@lenteratechnologies" target="_blank" rel="noopener noreferrer">
                          <img src={you} alt="YouTube" className="w-8 h-8" />
                        </a>
                        <a href="https://in.linkedin.com/company/lenteratechnologies" target="_blank" rel="noopener noreferrer">
                          <img src={lin} alt="LinkedIn" className="w-8 h-8" />
                        </a>
                        <a href="https://x.com/lenteratech" target="_blank" rel="noopener noreferrer">
                          <img src={twi} alt="X" className="w-8 h-8" />
                        </a>
                      </div>
      
                    </div>
      
                    {/* Services */}
                    <div className="w-full sm:w-[45%] md:w-auto">
                      <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">OUR SERVICES</h4>
                      <ul className="space-y-2 text-[#d4d4d4]">
                        <li><a href="/services/ai-services/" className="hover:text-white">AI services</a></li>
                        <li><a href="/services/web-development/" className="hover:text-white">Web development</a></li>
                        <li><a href="/services/mobile-app-development/" className="hover:text-white">Mobile app development</a></li>
                        <li><a href="/services/software-consulting/" className="hover:text-white">Software consulting</a></li>
                        <li><a href="/services/custom-development/" className="hover:text-white">Custom consulting</a></li>
                        <li><a href="/services/third-party-integration/" className="hover:text-white">Third party integration</a></li>
                        <li><a href="/services/enterprise-application/" className="hover:text-white">Enterprise Application</a></li>
                      </ul>
                    </div>
      
      
                    {/* Insights */}
                    <div className="w-full sm:w-[45%] md:w-auto">
                      <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">INSIGHTS</h4>
                      <ul className="space-y-2 text-[#d4d4d4]">
                        <li><Link to="/blogs" className="hover:text-white">Blog</Link></li>
                        <li><a href="https://www.lentera.in/careers/" className="hover:text-white">Careers</a></li>
                        <li><Link to="/blogs" className="hover:text-white">News</Link></li>
                      </ul>
                    </div>
      
                    {/* Contact */}
                    <div className="w-full md:w-auto">
                      <h4 className="text-white font-semibold mb-3 border-b-2 border-[#00A339] inline-block">CONTACT US</h4>
                      <div className="flex items-start gap-3 mb-3">
                        <img src={phonee} alt="phone" className="w-9 h-9 mt-1" />
                        <div>
                          <p className="text-[#999] text-sm">Phone number</p>
                          <a href="tel:+914448563345" className="text-white font-medium text-sm hover:underline">
                            +91-44-4856-3345
                          </a>
                        </div>
                      </div>
      
                      <div className="flex items-start gap-3 mb-3">
                        <img src={mail} alt="email" className="w-9 h-9 mt-1" />
                        <div>
                          <p className="text-[#999] text-sm">Email address</p>
                          <a href="mailto:info@lenteratech.com" className="text-white font-medium text-sm hover:underline">
                            info@lenteratech.com
                          </a>
                        </div>
                      </div>
      
                      <div className="flex items-start gap-3">
                        <img src={loc} alt="location" className="w-9 h-9 mt-1" />
                        <div>
                          <p className="text-[#999] text-sm">Location</p>
                          <a
                            href="https://www.google.com/maps?q=G1,+Plot+No+824+and+826,+3rd+Main+Rd,+Ram+Nagar+South,+Madipakkam,+Chennai,+Tamil+Nadu+600091"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-white font-medium text-sm hover:underline block"
                          >
                            G1, Plot No, 824 and 826, 3rd<br />
                            Main Rd, Ram Nagar South,<br />
                            Madipakkam, Chennai,<br />
                            Tamil Nadu 600091
                          </a>
                        </div>
                      </div>
      
      
                    </div>
                  </div>
                </div>
         </footer>
       
         {/* Bottom Section */}
         <div className="bg-[#23262E] border-t border-gray-700 text-sm text-[#ccc] flex flex-col md:flex-row justify-between items-center gap-2 py-4 px-4 sm:px-6 md:px-12 text-center md:text-left">
           <p>© 2025  Lentera Technologies Pvt Ltd. All rights reserved.</p>
           <div className="flex flex-wrap gap-4 justify-center md:justify-end">
             <a href="/terms-condition/" className="hover:underline">Terms and conditions</a>
             <a href="/privacy-policy/" className="hover:underline">Privacy Policy</a>
             <a href="/cookie-policy/" className="hover:underline">Cookies Policy</a>
             <a href="/copyright-information/" className="hover:underline">Copyright information</a>
           </div>
         </div>
       </div>
    </>
  );
};

export default BlogLanding;
